var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{staticClass:"hiq-assignments__filter-button",class:{'expanded': _vm.showFilter},on:{"click":function($event){return _vm.toggleFilter()}}},[_vm._v("Filtrera")])
}
var staticRenderFns = []

export { render, staticRenderFns }